import React, { Component } from 'react'
import PropTypes from 'prop-types';
import FirstPage from './RegistrationSteps/FirstPage'
import SecondPage from './RegistrationSteps/SecondPage'
import ThirdPage from './RegistrationSteps/ThirdPage'
import ForthPage from './RegistrationSteps/ForthPage'
import FifthPage from './RegistrationSteps/FifthPage'
import SixthPage from './RegistrationSteps/SixthPage'
import SeventhPage from './RegistrationSteps/SeventhPage'

import { Field, reduxForm } from 'redux-form'
import { dropdownsRequest } from '../../redux/reducers/dropdowns';
import { checkCodeRequest, resetCodeRequest } from '../../redux/reducers/checkProjectCode';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { shortRegistrationRequest,registrationRequest, loginReset, registrationPage1Request, registrationPage3Request, registrationPage2Request, setRegDone } from '../../redux/reducers/login';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import TextField from './TextField';
import  validate  from './validateReg';

import Spinner from '../Spinner';
import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBNotification, MDBSpinner } from "mdbreact";
import PasswordField from './PasswordField';
import EmailField from './EmailField';
import ModalPopup from '../Popups/ModalPopup';
import { COLORS, commonStyles, theme } from '../../styles/styles';

import PropagateLoader from 'react-spinners/PropagateLoader'
import logoLong from '../../assets/cs_icon.svg';
import SecondPageModal from './RegistrationSteps/SecondPageModal';
import ThirdPageModal from './RegistrationSteps/ThirdPageModal';
import FourthPageModal from './RegistrationSteps/FourthPageModal';


class ModalRegistrationForm extends Component {
  constructor(props) {
    super(props)
    this.nextPage = this.nextPage.bind(this)
    this.skipPages = this.skipPages.bind(this)
    this.previousPage = this.previousPage.bind(this)
    this.backToOne = this.backToOne.bind(this)
    this.firstCheck = this.firstCheck.bind(this)
    this.state = {
      page: 1,
      formActivePanel1: 1,
      formActivePanel1Changed: false,
      pageTitle:'Contact Information',
      showLoader: false
    }
  }

  componentWillReceiveProps(nextProps){
    
     if(!this.props.login.fetchedPageReg && nextProps.login.fetchedPageReg && this.props.login.user.isComplete==1 && !this.props.login.error){
        this.swapFormActive2(1)(this.state.page + 1 )
         this.setState({ page: this.state.page + 1 })
     }else if(!this.props.login.fetchedPageReg && nextProps.login.fetchedPageReg && this.props.login.user && this.props.login.user.isComplete==2 && !this.props.login.error){
      
      this.swapFormActive2(1)(4 )
      this.setState({ page: 4 })
     }else{
      this.setState({showLoader:false})
     }
    }


    
  swapFormActive = (a) => (param) => (e) => {
    
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
  swapFormActive2 = (a) => (param)=>{
    
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
    
  handleNextPrevClick = (a) => (param) => (e) => {
    this.setState({
      ['formActivePanel' + a]: param,
      ['formActivePanel' + a + 'Changed']: true
    });
  }
    
  handleSubmission = () => {
   
  }
    
  calculateAutofocus = (a) => {
    if (this.state['formActivePanel' + a + 'Changed']) {
      return true
    }
  }
    
  nextPage = () => {
    if(this.state.formActivePanel1 === 1){
      this.props.registrationPage1Request()
    }
    if(this.state.formActivePanel1 === 2){
      this.props.registrationPage2Request()
    }
    if(this.state.formActivePanel1 === 3){
      this.props.registrationPage3Request()
    }
    // this.swapFormActive2(1)(this.state.page + 1 )
    // this.setState({ page: this.state.page + 1 })
  }

  skipPages = () => {
    this.swapFormActive2(1)(6)
    this.setState({ page: 6 })
  }

  backToOne=()=> {
   
    this.props.resetCodeRequest()
    this.swapFormActive2(1)(1 )
    this.setState({ page: 1 })
  }

  previousPage=()=> {
    if(this.state.page==2){
      this.props.resetCodeRequest()
    }
    this.swapFormActive2(1)(this.state.page - 1 )
    this.setState({ page: this.state.page - 1 })
  }

  setTitle=(title)=> {
    
    this.setState({ pageTitle: title })
  }

  firstCheck=()=> {
     
    // if(this.state.page==1){
      this.props.checkCodeRequest()
  //  }

   
  }

  showShortReg = () => {
    const { onSubmit,onSubmitShort, onCheck, showLoader, checkCode, login, internet, showStartAlert, handleStart, dropdowns } = this.props
return <MDBContainer fluid style={{position:'absolute', top:0, left:0, backgroundColor:'rgba(0,0,0,0.5', zIndex:9999999}}>
    {!showStartAlert ? <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
      <MDBCol md="6" className="noSpacingMobile">
        <MDBCard className="noShadowMobile" style={{maxHeight:'90vh'}}>
            <div className="text-center  text-dark font-weight-bold pt-4 pb-2">
             {this.state.formActivePanel1 === 1 && (
              <strong>CONTACT DETAILS</strong>
            )} 
            </div>
            <div className='secondary-color pt-4 pb-4'>
            
            </div>
            <MDBCardBody>
              <MDBRow>
                {this.state.formActivePanel1 === 1 && (
                   <SecondPageModal previousPage={this.previousPage} onSubmit={this.nextPage}/>
                )}
                {this.state.formActivePanel1 === 4 && (
                  <SixthPage previousPage={this.previousPage} onSubmit={onSubmit}/>
                )}

               
              </MDBRow>
           
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      
    </MDBRow> : 
    <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
    <MDBCol md="6" className="noSpacingMobile">
      <MDBCard className="noShadowMobile">
  
          <div className='default-color pt-4 pb-4' style={{color:'#FFF', padding:40, borderRadius: '8px 8px 0 0'}}>
           Thank you for participating in one of our programs. Before you continue please provide us with some personal details for our records.
          </div>
          <MDBCardBody>
            <MDBRow>
            <MDBBtn color="success"
              right
              style ={{margin:'50px auto 0'}}
              action
              size="md"
              onClick={handleStart}>Let's Go</MDBBtn>
    

            </MDBRow>
         
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
    
  </MDBRow>
    
    
    }
    {this.state.showLoader && <div style={{position:'absolute', width:'100%', height:'100%', backgroundColor:'rgba(255,255,255,0.7'}}>
      <MDBSpinner primary lg/>
      </div>}
     
    {(checkCode.codeMessage && checkCode.codeMessage.message) && <ModalPopup icon="exclamation-circle" color='secondary' title='Error' body={checkCode.codeMessage.message}  showClose={true}/>
                  
                
             }
    
     {(dropdowns.error || login.error) && <ModalPopup icon="exclamation-circle" color='secondary' title='Network Error' body={'Please check your internet connection and refresh the page to continue.'} showModal={dropdowns.error || login.error} closeModal={this.closeModal} showClose={false}/> }

  </MDBContainer>

  }

  showFullReg = () => {
    const { onSubmit,onSubmitShort, onCheck, showLoader, checkCode, login, internet, showStartAlert, handleStart, dropdowns } = this.props

    
    return <MDBContainer fluid style={{position:'absolute', top:0, left:0, backgroundColor:'rgba(0,0,0,0.5', zIndex:9999999}}>
    {!showStartAlert ? <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
      <MDBCol md="6" className="noSpacingMobile">
        <MDBCard className="noShadowMobile" style={{maxHeight:'90vh'}}>
            <div className="text-center  text-dark font-weight-bold pt-4 pb-2">
             {this.state.formActivePanel1 === 1 && (
              <strong>POSITION DETAILS</strong>
            )} 
            {this.state.formActivePanel1 === 2 && (
              <strong>EDUCATION &amp; STATUS</strong>
            )}
             {this.state.formActivePanel1 === 3 && (
              <strong>EDUCATION &amp; STATUS</strong>
            )}
             {this.state.formActivePanel1 === 4 && (
              <strong>LEGAL DECLARATION</strong>
            )}
              {this.state.formActivePanel1 === 5 && (
              <strong>LEGAL DECLARATION</strong>
            )}
            </div>
            <div className='default-color pt-4 pb-4'>
            {(this.state.formActivePanel1 !== 5) && <MDBStepper form>
              <MDBStep form>
                <a href="#formstep1" >
                  <MDBBtn color={ this.state.formActivePanel1===1 ? "white" : "default" } circle className='border border-white'>
                    1
                  </MDBBtn>
                </a>
              
              </MDBStep>
              <MDBStep form>
                <a href="#formstep2" >
                  <MDBBtn color={ this.state.formActivePanel1===2 ? "white" : "default" } circle className='border border-white'>
                    2
                  </MDBBtn>
                </a>
              
              </MDBStep>
              <MDBStep form>
                <a href="#formstep3">
                  <MDBBtn color={ this.state.formActivePanel1===3 ?  "white" : "default" } circle className='border border-white'>
                    3
                  </MDBBtn>
                </a>
               
              </MDBStep>
              <MDBStep form>
                <a href="#formstep4">
                  <MDBBtn color={ this.state.formActivePanel1===4 ?  "white" : "default" } circle className='border border-white'>
                    4
                  </MDBBtn>
                </a>
              
              </MDBStep>

            </MDBStepper>}
            </div>
            <MDBCardBody>
              <MDBRow>
                {this.state.formActivePanel1 === 1 && (
                   <SecondPageModal previousPage={this.previousPage} onSubmit={this.nextPage}/>
                )}
                {this.state.formActivePanel1 === 2 && (
                   <ThirdPageModal previousPage={this.previousPage} onSubmit={this.nextPage}/>
                )}
                {this.state.formActivePanel1 === 3 && (
                  <FourthPageModal previousPage={this.previousPage} onSubmit={this.nextPage}/>
                )}

                {this.state.formActivePanel1 === 4 && (
                  <SixthPage previousPage={this.previousPage} onSubmit={onSubmit}/>
                )}

                {this.state.formActivePanel1 === 5 && (
                  <SeventhPage previousPage={this.backToOne} onSubmit={onSubmitShort}/>
                )}

              </MDBRow>
           
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
      
    </MDBRow> : 
    <MDBRow center  style={{alignItems: 'center', display: 'flex', height: '100vh'}}>
    <MDBCol md="6" className="noSpacingMobile">
      <MDBCard className="noShadowMobile">
  
          <div className='default-color pt-4 pb-4' style={{color:'#FFF', padding:40, borderRadius: '8px 8px 0 0'}}>
           Thank you for participating in one of our programs. Before you continue please provide us with some personal details for our records.
          </div>
          <MDBCardBody>
            <MDBRow>
            <MDBBtn
            className="btn btn-green mt-4"
      right
      size="md"
      style ={{margin:'0 auto'}}
      action
      onClick={handleStart}>Let's Go</MDBBtn>
    

            </MDBRow>
         
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
    
  </MDBRow>
    
    
    }
    {this.state.showLoader && <div style={{position:'absolute', width:'100%', height:'100%', backgroundColor:'rgba(255,255,255,0.7'}}>
      <MDBSpinner primary lg/>
      </div>}
     
    {(dropdowns.error || checkCode.error || login.error) && <ModalPopup icon="exclamation-circle" color='secondary' title='Network Error' body={'Please check your internet connection and refresh the page to continue.'} showModal={dropdowns.error || checkCode.error || login.error} closeModal={this.closeModal} showClose={false}/> }

   </MDBContainer>
  }

  render() {
    const { onSubmit,onSubmitShort, onCheck, showLoader, checkCode, login, internet, showStartAlert, handleStart } = this.props
    const { page, pageTitle } = this.state
    
    return (
      <div>
        
       {(login.user && login.user.isComplete==1 && login.regDone==false) ? this.showFullReg() : (login.user && login.user.isComplete==2 && login.regDone==false) ? this.showShortReg() : null}
    
   </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  shortRegistrationRequest: () => dispatch(shortRegistrationRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
  checkCodeRequest: () => dispatch(checkCodeRequest()),
  registrationPage1Request: () => dispatch(registrationPage1Request()),
  registrationPage2Request: () => dispatch(registrationPage2Request()),
  registrationPage3Request: () => dispatch(registrationPage3Request()),
  resetCodeRequest: () => dispatch(resetCodeRequest()),
  setRegDone: () => dispatch(setRegDone())
});

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
  checkCode: state.checkCodeReducer,
  internet:state.checkInternetReducer
});


export default compose(
  reduxForm({  form: 'registration',                 // <------ same form name
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
}),
  withState('showSpinner', 'toggleSpinner', false),
  withState('showStartAlert', 'toggleStartAlert', true),
  connect(mapStateToProps, mapDispatchToProps),
  withState('showLoader', 'toggleLoader', false),
  withHandlers({
    onSubmit: props => (values) => {
      const { showLoader } = props;
      //validateRegistration(values);
      //validateLogin(values);
      //props.toggleLoader(!showLoader);
      //props.registrationRequest();
      
      props.setRegDone()
    },
    handleStart: props => () => {
      props.dropdownsRequest()
      props.toggleStartAlert(!props.showStartAlert)
    },
    onSubmitShort: props => (values) => {
      const { showLoader } = props;
      //validateRegistration(values);
      //validateLogin(values);
      
      props.toggleLoader(!showLoader);
     // props.shortRegistrationRequest();
    },
    onCheck: props => (values) => {
      //validateRegistration(values);
      //validateLogin(values);
     
      props.checkCodeRequest();
     
    },
    handleLoader: props => (values) => {
      //validateRegistration(values);
      //validateLogin(values);
     
      
    },
  }),
  withStyles(styles),
  lifecycle({
    componentWillMount() {
      // !this.props.dropdowns.isFetched && this.props.dropdownsRequest();
    }
  }),
)(ModalRegistrationForm);


const styles = () => ({
    ...commonStyles,
    halfField: {
        display: 'inline-flex',
        width: '49%',
    },
    paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(4),
      outline: 'none',
    },
    firstInRow: {
        marginRight: '2%',
    },
    fullField: {
        width: '100%',
    },
    regFormWrapper: {
        maxWidth: '80%',
        margin: '0 auto',
    },
    rowWrapper: {
        display: 'flex',
    },
    noTopLabel: {
        paddingTop: 10,
        paddingLeft: 14,
    },
});